import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./theme/tokens.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ConfigProvider } from "antd";
import muiTheme from "./theme/muiTheme";
import antdTheme from "./theme/antdTheme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={muiTheme}>
    <ConfigProvider theme={antdTheme}>
      <CssBaseline />
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </ConfigProvider>
  </ThemeProvider>,
);

reportWebVitals();
